import React, { FC, useRef, useEffect } from 'react';
import { Messages } from '@marriott/mi-ui-library';

import { usePrivacyRightsStore } from '../../store';
import { LegalTextWithLink } from '../../molecules/LegalTextWithLink';
import { PrivacyRightsAlertComponentType } from './PrivacyRightsWrapper.types';

export const PrivacyRightsAlertComponent: FC<PrivacyRightsAlertComponentType> = ({
  unAuthSuccessfulSubmission,
  authSuccessfulSubmission,
  profileNotFound,
  apiFailed,
  authProfileIsInEligible,
}) => {
  const alertRef = useRef<HTMLDivElement>(null);

  const { showAlertComponent, alertType } = usePrivacyRightsStore(state => state.alertComponentConfig);

  useEffect(() => {
    if (showAlertComponent && alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  const alertConfig = {
    apiError: { messageType: 'error-sev1', messageText: apiFailed },
    profileNotFound: { messageType: 'error-sev1', messageText: profileNotFound },
    authIneligible: { messageType: 'warning', messageText: authProfileIsInEligible },
    profileUpdated: { messageType: 'success', messageText: unAuthSuccessfulSubmission },
    authProfileUpdated: { messageType: 'success', messageText: authSuccessfulSubmission },
  };

  const alertData = alertType ? alertConfig[alertType] : null;

  return showAlertComponent && alertData ? (
    <div ref={alertRef} data-testid="privacyRights-Alert-Msg">
      <Messages messageType={alertData.messageType} className="mb-5">
        <LegalTextWithLink
          className="alert"
          descriptionText={alertData.messageText}
          testId="legal-privacy-alert-message"
          innerChildClassName="mt-0 mb-0"
        />
      </Messages>
    </div>
  ) : null;
};
